import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FaqQuestionsComponent } from './faq-questions/faq-questions.component';
import { FaqContactComponent } from './faq-contact/faq-contact.component';
import { clearPaginas, pushPaginaAtiva } from '../../shared/activePage';

@Component({
  selector: 'app-faq',
  imports: [
    CommonModule,
    FaqQuestionsComponent,
    FaqContactComponent
  ],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit {

  isFaqActive: boolean = true;

  ngOnInit(): void {
    clearPaginas();
    pushPaginaAtiva({
        nome: 'Home',
        rota: '/home'
    });
    pushPaginaAtiva({
        nome: 'Ajuda e suporte',
        rota: ''
    });
  }

  toggleActiveScreen(boolean: boolean) {
    this.isFaqActive = boolean
  }
}
